module.exports = __webpack_public_path__ + "img/khoi-6.5cedcffa.svg";